import React, { useRef, useEffect } from 'react';
import { Paper, MenuList, MenuItem, Typography } from '@mui/material';
import { motion } from 'framer-motion';

import type { SlashCommandShortcut } from '../constants';
import './SlashCommandMenu.scss';

interface SlashCommandMenuProps {
  shortcuts: SlashCommandShortcut[];
  selectedIndex: number;
  onSelect: (shortcut: SlashCommandShortcut) => void;
}

const SlashCommandMenu: React.FC<SlashCommandMenuProps> = ({
  shortcuts,
  selectedIndex,
  onSelect,
}) => {
  const menuRef = useRef<HTMLUListElement>(null);
  const selectedItemRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    selectedItemRef.current?.scrollIntoView({ block: 'nearest' });
  }, [selectedIndex]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 6 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="slash-command-menu-wrapper"
    >
      <Paper className="slash-command-menu" elevation={0}>
        <MenuList ref={menuRef} className="slash-command-menu__list">
          {shortcuts.map((shortcut, index) => (
            <motion.div
              key={shortcut.command}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2, delay: index * 0.04, ease: 'easeOut' }}
            >
              <MenuItem
                ref={index === selectedIndex ? selectedItemRef : null}
                selected={index === selectedIndex}
                onClick={() => onSelect(shortcut)}
                className="slash-command-menu__item"
              >
                <Typography className="slash-command-menu__item__command">
                  {shortcut.command}
                </Typography>
              </MenuItem>
            </motion.div>
          ))}
        </MenuList>
      </Paper>
    </motion.div>
  );
};

export default SlashCommandMenu;
